var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2272_7063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.392 11.242 5.407 7.258l3.985-3.984a.54.54 0 0 0 .163-.391.54.54 0 0 0-.163-.391.546.546 0 0 0-.776 0L4.24 6.867a.54.54 0 0 0-.158.39c0 .147.059.287.158.386l4.375 4.369c.216.216.56.216.776 0a.56.56 0 0 0 .163-.385.53.53 0 0 0-.163-.385"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2272_7063"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.083 2.334h5.472v9.841H4.083z"
  })))));
};
export default SvgArrowLeft;